export default __webpack_public_path__ + "static/media/img-gastronomy.eac4921f.jpg";